// @mui
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// hooks
// routes
// locales
// components
import { useAuthContext } from 'src/auth/hooks';
import Label from 'src/components/label';

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  // use reducer to get user
  const { user } = useAuthContext();



  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Box sx={{ position: 'relative' }}>
          <Avatar
            src={user?.user_metadata.avatar_url}
            alt={user?.user_metadata.full_name}
            sx={{ width: 48, height: 48 }}
          />
          <Label
            color="success"
            variant="filled"
            sx={{
              top: -6,
              px: 0.5,
              left: 40,
              height: 20,
              position: 'absolute',
              borderBottomLeftRadius: 2,
            }}
          >
            Active
          </Label>
        </Box>

        <Stack spacing={0.5} sx={{ mt: 1.5, mb: 2 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.user_metadata.full_name}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            {user?.email.endsWith('@student.thebsbh.com') ? 'Student' : 'Teacher'}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
